import { ValidatorFn, AbstractControl } from '@angular/forms';

export function numValidation(): ValidatorFn{
  return (control:AbstractControl):{[key: string]:any} | null => {
    let name:RegExp=/^[0-9]+$/g;
    const forbidden = name.test(control.value);
    return forbidden ? null :{'number':{value:control.value}};
  };
}

export function decimal():ValidatorFn{
  return (control:AbstractControl):{[key: string]:any} | null => {
    let name:RegExp=/[+-]?([0-9]*[.])?[0-9]+/g;
    const forbidden = name.test(control.value);
    return (forbidden && !isNaN(control.value)) ? null :{'decimal':{value:control.value}};
  };
}

export function mobile():ValidatorFn{
  return (control:AbstractControl):{[key: string]:any} | null => {
    let name:RegExp=/^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$|^$/g;
    const forbidden = name.test(control.value);
    return forbidden ? null :{'mobile':{value:control.value}};
  };
}

export function email():ValidatorFn{
  return (control:AbstractControl):{[key: string]:any} | null => {
    let name:RegExp=/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$|^$/g;
    const forbidden = name.test(control.value);
    return forbidden ? null :{'email':{value:control.value}};
  };
}

export function panCard():ValidatorFn{
  return (control:AbstractControl):{[key: string]:any} | null => {
    let name:RegExp=/^([A-Z]){5}([0-9]){4}([A-Z]){1}?$|^$/g;
    const forbidden = name.test(control.value);
    return forbidden ? null :{'pancard':{value:control.value}};
  };
}
